import "../scss/register.scss";
import * as translation from './translations'
import {AjaxRequest} from "./ajax-request";
import {togglePassword} from "./passwordToggle";
import {getItem} from "./localStorage";
import "./data-form";
import {customSelect} from "./custom-select";

customSelect('#sex');


$(document).ready(function () {

    const spinner = document.querySelector('.spinner');
    togglePassword('#password_toggle');
    const ajaxRequest = new AjaxRequest();
    let membershipSelected = getItem('membership');
    let selectedClubId = getItem('clubId');
    let type = getItem('type');


    if (type === "medicover") {
        document.querySelector(".with_popUp").classList.add('show')
    }

    function lowercaseFirstLetter(str) {
        if (!str) return str;
        return str.charAt(0).toLowerCase() + str.slice(1);
    }


    function addIFormValidation(fields) {
        fields.forEach(field => {
            let name = lowercaseFirstLetter(field.name);
            if (!name.includes("company")) {
                console.log("nazwa" + name)
                $(`#${name}`).rules('add', {
                    required: true,
                    messages: {
                        required: translation.translations[translation.lang].required,
                    }
                });
            }
        })
    }


    if (!membershipSelected || !selectedClubId) {
        window.location.href = '/'
    }
    getRegistrationFields(selectedClubId, membershipSelected).then(res => {
        spinner.style.display = "none";
        let data = res['data']['results'].filter(field => field.isRequired);
        addIFormValidation(data);

    })

    async function getConsentDefinitions(clubId, id) {
        spinner.style.display = "flex"
        let data = {
            id: id,
            clubId: clubId
        }
        try {
            return await ajaxRequest.request('my_ajax_get_consent_definitions', data);
        } catch (error) {
            console.log(error)
        }
    }

    async function getRegistrationFields(clubId, id) {
        spinner.style.display = "flex"
        let data = {
            id: id,
            clubId: clubId
        }
        try {
            return await ajaxRequest.request('my_ajax_get_registration-fields', data);

        } catch (error) {
            console.log(error)
        }
    }

});











